import React, { useState, useEffect } from "react";
import Multiselect from "multiselect-react-dropdown";
import DropzoneVideo from "../../components/dropzone/DropzoneVideo";
import { useDropzone } from "react-dropzone";
import StoriesService from "../../services/StoriesService";

import { toast } from "react-toastify";

const AddEditInstructionModel = ({ type, instructor = {} }) => {
  const [stories, setStories] = useState([]);
  const [locations, setLocations] = useState([]);
  const [activeLocation, setActiveLocation] = useState(
    instructor.locations ?? ""
  );
  const [mediaUrl, setMediaUrl] = useState(null);
  const [selectedStories, setSelectedStories] = useState([]);

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone();

  let dropzoneClass = "dropzone";
  if (isDragActive) dropzoneClass += " dropzone-active";
  if (isDragAccept) dropzoneClass += " dropzone-accept";
  if (isDragReject) dropzoneClass += " dropzone-reject";

  const getAllStories = async () => {
    try {
      const response = await StoriesService.getStories();
      if (response) {
        setStories(response);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const onSelectStory = (selectedList, selectedItem) => {
    var ids = selectedList.map((item) => item._id);
    setLocations(ids);
  };

  const onRemoveStory = (selectedList, removedItem) => {
    var ids = selectedList.map((item) => item._id);
    setLocations(ids);
  };

  const handleActiveLocation = (e) => {
    setActiveLocation(e.target.value);
  };

  const addInstruction = async (event) => {
    try {
      event.preventDefault();

      const formData = new FormData(event.target);
      formData.append("media", mediaUrl);
      formData.append("storyLocation", locations);

      const response = null;
      if (response) {
        toast.success("Instruction uploaded");
        window.location.reload();
      }
    } catch (error) {}
  };

  const editInstruction = async (event) => {
    try {
      event.preventDefault();
      const formData = new FormData(event.target);
      formData.append("media", mediaUrl);
      formData.append("instruction", instructor._id);
      formData.append("storyLocation", locations);
      const response = null;
      if (response) {
        toast.success("Instruction updated");
        window.location.reload();
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAllStories();
  }, []);

  useEffect(() => {
    if (instructor.storyLocation) {
      const selectedX = stories.filter((d) =>
        instructor.storyLocation.includes(d._id)
      );
      setSelectedStories(selectedX);
    }
  }, [stories]);

  return (
    <div>
      <form onSubmit={type == "Add" ? addInstruction : editInstruction}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalToggleLabel">
                {type == "Add" ? "Add Instruction" : "Edit Instruction"}
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <label for="instruction-number" className="col-form-label">
                  Instruction No.
                </label>
                <input
                  name="instructionNumber"
                  type="text"
                  className="form-control truncate"
                  id="instruction-number"
                  placeholder="Instruction No."
                  defaultValue={instructor?.instructionNumber}
                />
              </div>
              <div className="mb-3">
                <label for="title" className="col-form-label">
                  Title
                </label>
                <input
                  type="text"
                  className="form-control truncate"
                  id="title"
                  placeholder="Title"
                  name="title"
                  defaultValue={instructor?.title}
                />
              </div>
              <div className="mb-3">
                <label for="location" className="col-form-label">
                  Location
                </label>
                <select
                  defaultValue={instructor?.locations}
                  onChange={handleActiveLocation}
                  name="locations"
                  className="form-select"
                  id="location"
                >
                  <option value="Create Account">Create Account</option>
                  <option value="Log in">Log in</option>
                  <option value="Reset Password">Reset Password</option>
                  {/* <option value="Landing Page">Landing Page</option> */}
                  <option value="Edit Profile">Edit Profile</option>
                  <option value="Add Website">Add Website</option>
                  <option value="Record Thoughts">Record Thoughts</option>
                  <option value="Record thoughts, 2nd chance">
                    Record thoughts, 2nd chance
                  </option>
                  <option value="Message Center">Message Center</option>
                  {/* <option value="Stories">Stories</option> */}
                </select>
              </div>
              {activeLocation == "Stories" && (
                <div className="mb-3">
                  <label htmlFor="recipient-name" className="col-form-label">
                    Stories Location
                  </label>
                  <Multiselect
                    options={stories}
                    selectedValues={selectedStories}
                    onSelect={onSelectStory}
                    onRemove={onRemoveStory}
                    displayValue="title"
                  />
                </div>
              )}
              <div className="mb-3">
                <label for="media" className="col-form-label">
                  Media
                </label>
                <DropzoneVideo onVideoSelect={setMediaUrl} title="media" />
              </div>
            </div>

            <div className="modal-footer">
              <button
                id={`${type}-instruction`}
                className="btn-model"
                type="submit"
              >
                {type} Instruction
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default AddEditInstructionModel;
